export interface IBuildingPermit {
    PermitNumber: string;
    DateApplication: string;
    DateIssued: string;
    ProjectDescription: string;
    MostRecentInspect: string;
    PermitStatus: string;
    EstimatedValue: string;
    Address: string;
}

export class BuildingPermit implements IBuildingPermit {
    public PermitNumber = '';
    public DateApplication = '';
    public DateIssued = '';
    public ProjectDescription = '';
    public MostRecentInspect = '';
    public PermitStatus = '';
    public EstimatedValue = '';
    public Address = '';
    constructor(
        permitObject: any,
    ) {
        this.PermitNumber = permitObject.permitNumber;
        this.DateApplication = permitObject.dateApplication;
        this.DateIssued = permitObject.dateIssued;
        this.ProjectDescription = permitObject.projectDescription;
        this.MostRecentInspect = permitObject.mostRecentInspect;
        this.PermitStatus = permitObject.permitStatus;
        this.EstimatedValue = permitObject.estimatedValue;
        this.Address = permitObject.address;
    }
}
